import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "term", "counter", "submit", "manualInput", "limitMessage"]
  static values = { remaining: Number }

  connect() {
    this.update()
  }

  acceptAll() {
    this.checkboxTargets.forEach((checkbox) => (checkbox.checked = true))
    this.update()
  }

  rejectAll() {
    this.checkboxTargets.forEach((checkbox) => (checkbox.checked = false))
    this.update()
  }

  update() {
    // A suggestion edited down to blank would otherwise still count toward
    // the selected total even though the server drops blank terms silently.
    this.checkboxTargets.forEach((checkbox) => {
      if (!checkbox.checked) return

      const row = checkbox.closest(".list-group-item")
      const termInput = row?.querySelector('[data-keyword-suggestions-target~="term"]')
      if (termInput && termInput.value.trim() === "") checkbox.checked = false
    })

    const checkedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    const total = checkedCount + this.manualTermCount()

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${total} keyword${total === 1 ? "" : "s"} selected`
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = total === 0
    }

    if (this.hasLimitMessageTarget) {
      const overLimit = this.hasRemainingValue && this.remainingValue >= 0 && total > this.remainingValue
      this.limitMessageTarget.classList.toggle("d-none", !overLimit)
      if (overLimit) {
        this.limitMessageTarget.textContent =
          this.remainingValue === 0
            ? "You're at your plan's keyword limit. None of these will be added."
            : `Only the first ${this.remainingValue} keyword${this.remainingValue === 1 ? "" : "s"} will be added. The rest will be skipped.`
      }
    }
  }

  manualTermCount() {
    if (!this.hasManualInputTarget) return 0

    return this.manualInputTarget.value
      .split(/[\n,]+/)
      .map((term) => term.trim())
      .filter(Boolean).length
  }
}
